import { render, staticRenderFns } from "./PracticeTests.vue?vue&type=template&id=23502487"
import script from "./PracticeTests.vue?vue&type=script&lang=js"
export * from "./PracticeTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports